import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Star, ChevronRight, Scale, Zap } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import './BestSellers.css';

const BestSellers = () => {
  const [bestSellers, setBestSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const q = query(collection(db, "products"), where("isBestSeller", "==", true));
        const querySnapshot = await getDocs(q);
        setBestSellers(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error("Hata:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBestSellers();
  }, []);

  if (loading || bestSellers.length === 0) return null;

  return (
    <section className="best-sellers-premium-section">
      <div className="container">
        <div className="bs-header-area">
          <div className="bs-title-box">
            <div className="bs-badge"><Star size={14} fill="#f59e0b" /> ÇOK SATANLAR</div>
            <h2>Bigma'nın <span>Gözdesi</span> Olan Üretimler</h2>
          </div>
          <button className="bs-all-btn" onClick={() => navigate('/urunlerimiz')}>
            Tümünü İncele <ChevronRight size={18} />
          </button>
        </div>

        <Swiper
          modules={[Autoplay, Navigation, FreeMode]}
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          freeMode={true}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 }
          }}
          className="best-sellers-swiper"
        >
          {bestSellers.map((product) => (
            <SwiperSlide key={product.id}>
              <div 
                className="bs-product-card"
                onClick={() => navigate(`/urun/${product.id}`, { state: { product } })}
              >
                <div className="bs-img-wrapper">
                  <img src={product.imageUrl} alt={product.name} />
                  <div className="bs-card-overlay">
                    <span className="bs-quick-info">Hızlı İncele</span>
                  </div>
                </div>
                
                <div className="bs-info-box">
                  <span className="bs-cat">{product.subType?.toUpperCase()}</span>
                  <h3>{product.name}</h3>
                  <div className="bs-meta">
                    <div className="m-item"><Scale size={14} /> {product.weight} KG</div>
                    <div className="m-item"><Zap size={14} /> {product.type || "Pelet"}</div>
                  </div>
                  <div className="bs-card-line"></div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BestSellers;